import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { SharedModules } from "src/app/shared.modules";
import { DialogInfoComponent } from "./dialog-info.component";
import { DialogDefaultModalComponent } from "../dialog-default-modal/dialog-default-modal.component";
import { ButtonComponent } from "../button/button.component";

@NgModule({
  declarations: [DialogInfoComponent],
  imports: [CommonModule, SharedModules, DialogDefaultModalComponent, ButtonComponent],
})
export class DialogInfoModule {}
